import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {useState} from "../../../__snowpack__/pkg/react.js";
const useLastUpdatedMvIds = () => {
  const [lastUpdatedMvIds, setLastUpdatedMvIds] = useState([]);
  return {
    lastUpdatedMvIds,
    setLastUpdatedMvIds
  };
};
export const useLastUpdatedMvIdsModel = createModel(useLastUpdatedMvIds);
const useSelectedKeys = () => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  return {selectedKeys, setSelectedKeys};
};
export const useSelectedKeysModel = createModel(useSelectedKeys);
const useFailedPriceSettings = () => {
  const [failedPriceSettings, setFailedPriceSettings] = useState([]);
  return {
    failedPriceSettings,
    setFailedPriceSettings
  };
};
export const useFailedPriceSettingsModel = createModel(useFailedPriceSettings);
